import React, { useRef, useState, useCallback, useEffect } from 'react';
import { useGLTF } from '@react-three/drei';
import { useFormStore } from '../../state/FormStore';


export function Spie({ verandaSize, verandaColor, opaalTexture, verandaStartPosition, nodes, materials }) {
    const { formData, getLeftSpieColor, getRightSpieColor } = useFormStore();

    const leftSpieColor = getLeftSpieColor();
    const rightSpieColor = getRightSpieColor();

    return (

        <group scale={[verandaSize[0], verandaSize[1], verandaSize[2]]}>

            {formData.linker.linker_spie_option !== 'Geen' && (
                <>

                    <mesh
                        castShadow
                        receiveShadow
                        geometry={nodes.spie_mat_left.geometry}
                        material={nodes.spie_mat_left.material}>
                        <meshStandardMaterial attach="material" map={opaalTexture} color={leftSpieColor[0]} transparent opacity={leftSpieColor[1]} />
                    </mesh>
                    {formData.linker.linker_spie_option.includes('Glas') ? (
                        <>
                            <mesh
                                castShadow
                                receiveShadow
                                geometry={nodes.spie_left_mprofile.geometry}>
                                <meshStandardMaterial attach="material" color={verandaColor[0]} />
                            </mesh>
                            <mesh
                                castShadow
                                receiveShadow
                                geometry={nodes['glass-spie_left'].geometry}
                            >
                                <meshStandardMaterial attach="material" color={verandaColor[0]} />
                            </mesh>

                        </>
                    ) : (
                        <>
                            <mesh
                                castShadow
                                receiveShadow
                                geometry={nodes['Alu-spie_left'].geometry}>
                                <meshStandardMaterial attach="material" color={verandaColor[0]} />
                            </mesh>
                        </>
                    )}
                </>
            )}

            {formData.rechter.rechter_spie_option !== 'Geen' && (
                <>

                    <mesh
                        castShadow
                        receiveShadow
                        geometry={nodes.spie_mat_right.geometry}
                        material={nodes.spie_mat_right.material}>
                        <meshStandardMaterial attach="material" map={opaalTexture} color={rightSpieColor[0]} transparent opacity={rightSpieColor[1]} />
                    </mesh>
                    {formData.rechter.rechter_spie_option.includes('Glas') ? (
                        <>
                            <mesh
                                castShadow
                                receiveShadow
                                geometry={nodes.spie_right_mprofile.geometry}>
                                <meshStandardMaterial attach="material" color={verandaColor[0]} />
                            </mesh>
                            <mesh
                                castShadow
                                receiveShadow
                                geometry={nodes['glass-spie_right'].geometry}
                            >
                                <meshStandardMaterial attach="material" color={verandaColor[0]} />
                            </mesh>

                        </>
                    ) : (
                        <>
                            <mesh
                                castShadow
                                receiveShadow
                                geometry={nodes['Alu-spie_right'].geometry}>
                                <meshStandardMaterial attach="material" color={verandaColor[0]} />
                            </mesh>
                        </>
                    )}
                </>
            )}


        </group>
    );
}

//useGLTF.preload('/veranda3/veranda3.glb');
